// extracted by mini-css-extract-plugin
module.exports = {"container":"n2nds","list":"olSTJ","listItem":"_2N4uI"};